export const onInputHandlerToUpperCase = (e: React.SyntheticEvent) => {
  (e.target as HTMLInputElement).value = (
    '' + (e.target as HTMLInputElement).value
  ).toUpperCase();
};
